import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { isLoading, isNormal, useStatus, useData } from 'resift';
import makeStyles from '@material-ui/core/styles/makeStyles';
import makeGetRole from 'fetches/rolesAndPermissions/makeGetRole';

import CircularProgress from '@material-ui/core/CircularProgress';
import RoleManageForm from './RoleManageForm';

interface Props {
  onClose: () => void;
  fromEditUserId?: string;
}

function Container({ onClose, fromEditUserId }: Props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split('/').pop() || '';
  const getRole = makeGetRole(id);

  const status = useStatus(getRole);
  const data = useData(getRole);

  useEffect(() => {
    dispatch(getRole());
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" className={classes.loading} />;
  }

  if (!isNormal(status)) {
    return <div>Something went wrong.</div>;
  }

  return <RoleManageForm onClose={onClose} role={data} fromEditUserId={fromEditUserId} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  loading: {
    display: 'flex',
    margin: 'auto',
  },
}));

export default Container;
